import { useEffect, useRef } from 'react';

/**
 * Closes the submenu when the user clicks outside both the sidebar shell and the flyout panel.
 */
export function useSidebarSubmenuDismiss({ open, onClose, sidebarRef, panelRef }) {
  const onCloseRef = useRef(onClose);
  useEffect(() => {
    onCloseRef.current = onClose;
  });

  useEffect(() => {
    if (!open) return undefined;

    const handlePointerDown = (event) => {
      const target = event.target;
      if (!(target instanceof Node)) return;
      if (sidebarRef?.current?.contains(target)) return;
      if (panelRef?.current?.contains(target)) return;
      onCloseRef.current?.();
    };

    document.addEventListener('mousedown', handlePointerDown);
    return () => document.removeEventListener('mousedown', handlePointerDown);
  }, [open, sidebarRef, panelRef]);
}
